import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { http } from "@/lib/api";

export default function Clients() {
    const [clients, setClients] = useState([]);
    useEffect(() => {
        http.get("/clients")
            .then((r) => setClients(r.data || []))
            .catch(() => setClients([]));
    }, []);

    return (
        <section data-testid="clients-section" className="px-6 md:px-12 py-24 md:py-40 border-t border-white/5">
            <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24 items-end">
                <p className="col-span-12 md:col-span-2 text-[11px] tracking-[0.32em] uppercase text-white/45">
                    03 — Selected clients
                </p>
                <h2 className="col-span-12 md:col-span-10 font-display tracking-tightest leading-[0.78] text-4xl md:text-6xl lg:text-7xl text-white/80">
                    Hemos contado historias para
                    <span className="text-white"> marcas que importan.</span>
                </h2>
            </div>

            <div className="max-w-6xl mx-auto grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-x-4 gap-y-12 md:gap-y-16">
                {clients.map((c, i) => (
                    <ClientLogo key={c.id || c.name} c={c} i={i} />
                ))}

            </div>
        </section>
    );
}

function ClientLogo({ c, i }) {
    const [failed, setFailed] = useState(false);
    if (failed || !c.logo_url) return null;
    return (
        <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: (i % 6) * 0.04 }}
            className="flex items-center justify-center h-10 md:h-12"
            title={c.name}
            data-testid={`client-${(c.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
            <img
                src={c.logo_url}
                alt={c.name}
                loading="lazy"
                onError={() => setFailed(true)}
                className="max-h-full max-w-full object-contain opacity-65 hover:opacity-100 transition-opacity duration-700"
            />
        </motion.div>
    );
}
